export var expectedExpression = 'Expected a JavaScript expression';
export var expectedParen = 'Expected closing paren';

//# sourceMappingURL=/home/travis/build/ractivejs/ractive/.gobble-build/01-transpile/.cache/parse/converters/expressions/shared/errors.js.map
